import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllCourseSlice = createSlice({
  name: "getAllCourse",
  initialState: { data: null, pagination: false, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data.data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllCourseSlice;
const getAllCourseAction = createAction(name);

export {
  getAllCourseAction,
  actions as getAllCourseActions,
  reducer as getAllCourseReducer,
};
